export default "__VITE_ASSET__6a305f6c__"